import { render, staticRenderFns } from "./AgencySummarySectors.vue?vue&type=template&id=2fc97794&"
import script from "./AgencySummarySectors.vue?vue&type=script&lang=js&"
export * from "./AgencySummarySectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports